import { ChatMessage, DirectorRoleKey, ProjectDemoData } from './types';

// 帮助函数：提取上一轮AI输出中的第n个编号选项
export const extractNthItem = (conversation: ChatMessage[], n: number = 1): string => {
  // 从后往前找，找到最近的AI回复
  for (let i = conversation.length - 1; i >= 0; i--) {
    if (conversation[i].role === 'assistant') {
      const content = conversation[i].content;
      // 提取编号项目
      const items = content.split(/\n*(?:\d+\.\s+)/).filter(Boolean);
      if (n <= items.length) {
        return items[n - 1];
      }
      return items[items.length - 1];
    }
  }
  return '';
};

// 只在当前 Project + 当前角色 自己的 mockResponses 里做关键词匹配，
// 项目A的问题永远不可能匹配到项目B的回答，优化的问题也不会匹配到编导/剪辑的回答
export const findMockResponse = (
  userInput: string,
  project: ProjectDemoData,
  role: DirectorRoleKey,
  conversation: ChatMessage[]
): string => {
  const lowerInput = userInput.toLowerCase();
  const roleConfig = project.director[role];

  for (const mock of roleConfig.mockResponses) {
    for (const keyword of mock.keywords) {
      if (lowerInput.includes(keyword.toLowerCase())) {
        return mock.response(project, conversation);
      }
    }
  }

  return roleConfig.fallbackResponse;
};
